import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <div className="flex-1 w-full">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-6 font-heading">
            {t("home.about.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 font-body">
            {t("home.about.desc")}
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer font-body mb-8"
          >
            <span>{t("home.about.cta")}</span>
            <i className="ri-arrow-right-line" />
          </a>
          <div className="flex gap-8 md:gap-12">
            <div>
              <span className="text-3xl md:text-4xl font-bold text-foreground-900 font-body">15K+</span>
              <p className="text-xs text-foreground-500 mt-1 font-body">Produits</p>
            </div>
            <div>
              <span className="text-3xl md:text-4xl font-bold text-foreground-900 font-body">50+</span>
              <p className="text-xs text-foreground-500 mt-1 font-body">Marques</p>
            </div>
          </div>
        </div>
        <div className="flex-1 w-full relative">
          <div className="relative rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20European%20boutique%20interior%20with%20white%20clothing%20racks%20displaying%20colorful%20seasonal%20fashion%20collection%20warm%20track%20lighting%20on%20exposed%20concrete%20ceiling%20with%20green%20plants%20hanging%20industrial%20chic%20aesthetic%20editorial%20photography%20high%20detail&width=800&height=600&seq=about-img-v2&orientation=landscape"
              alt="Hipobuy Spreadsheet European fashion warehouse"
              className="w-full h-auto object-cover object-top"
              width={800}
              height={600}
            />
            <div className="absolute top-4 left-4">
              <span className="inline-block px-3 py-1 rounded-full bg-white text-foreground-900 text-xs font-semibold font-body">
                {t("home.about.tag")}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4 md:p-6">
              <p className="text-white text-sm font-body">Hipobuy Spreadsheet</p>
              <p className="text-white/80 text-xs font-body">Source européenne directe</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}